import {postRequest} from "../../../../common/helpers/RequestHelper";
class RefundPaymentService {
    apiLocation = "api/v1/pos/ecommerce/order/order_refund"
    public fetchSaveOrderRefund(params:any): Promise<any>{
        return postRequest(this.apiLocation,params);
    }
}

export const refundPaymentService = new RefundPaymentService()